import React from 'react'
import "./StandardPopup.css"

import { Modal } from "@mui/material";

import PopUpResponseButton from '../../Buttons/PopUpResponseButton/PopUpResponseButton';

/*
 yesFcn executes on clicking the yes button. it also automatically closes the popup.
 noFcn executes on clicking the no button. it also automatically closes the popup.
 message and message2 are rendered on different lines. Ghetto af
**/

export default function StandardPopup({isOpen,yesFcn,noFcn,onClose,message,message2,icon, buttonsEnabled = true, yesText = "Da", noText = "Nu"}) {


    const [open, setOpen] = React.useState(isOpen); // handles if popup is open. This has to be done outside of the component via state

    //this is so if it changes outside of this componenet it still updated this component. React shit
    React.useEffect(() => {
        setOpen(isOpen); 
    },[isOpen])

    const handleDismiss = () => {
        if (onClose) onClose();
        setOpen(false);
    };

    return <Modal open={open} onClose={onClose ? handleDismiss : undefined}>
    <div className="popupMembersContainer" data-testid="standardPopup">
      {icon && <img src={icon} alt="" />}
      <div className="popupMembersText">{message}</div>
      <div className="popupMembersText">{message2}</div>
      <div className="popupMembersButtonsContainer">
        {buttonsEnabled ? (
        <>
          <PopUpResponseButton
            type={"yes"}
            text={yesText}
            onClick={() => {
              if(yesFcn) {
                  yesFcn()
              }
              setOpen(false);
            }}
          />
          <PopUpResponseButton
            type={"cancel"}
            text={noText}
            onClick={() => {
              // setIsChanging(false);
              // setPopupOpen(false);
              if(noFcn) {
                  noFcn()
              }
              setOpen(false);
          }}
          />
        </>) : onClose && (
          <PopUpResponseButton
            type={"yes"}
            text={"OK"}
            onClick={handleDismiss}
          />
        )}
      </div>
    </div>
  </Modal>
}